// import React, {useState} from 'react';
// import {ScrollView} from 'react-native';
// import {useNavigation} from '@react-navigation/native';
// import {noop} from 'lodash';

// import Text from '/component/base/Text';
// import TouchableOpacity from '/component/base/TouchableOpacity';
// import Gutter from '/component/layout/Gutter';
// import NavigationHeader from '/component/layout/NavigationHeader';
// import {ContactWithCheckBox} from '/component/screen/CandidateProfile/ContactWithCheckBox';
// import NotesWithCheckbox from '/component/screen/CandidateProfile/NotesWithCheckbox';
// import {DownlineProfile} from '/constant/TestIDs';
// import {MERGE_PROFILES_TITLE} from '/enum/candidates.enum';
// import testProperties from '/util/testing/testProperties';

// import {getCloseIconPressHandler} from '../MergeCandidate.util';

// import {styles} from './SecondMergeScreen.style';
// import {generateOpenMergePopover} from './SecondMergeScreen.util';
// interface SecondMergeScreenProps {
//   onClosePress: () => void;
//   recordId: string;
//   mergeCandidate: (recordId: string, data: any) => Promise<void>;
//   popoverShow: () => void;
//   urlDetails: any[];
//   route: {
//     params: {
//       appendPhoneNumber: boolean;
//     };
//   };
//   clientDetails: {
//     id: string;
//   };
// }

// export const SecondMergeScreen: React.FC<SecondMergeScreenProps> = ({
//   onClosePress = noop,
//   recordId,
//   mergeCandidate = noop,
//   popoverShow = noop,
//   urlDetails = [],
//   route = {params: {appendPhoneNumber: false}},
//   clientDetails: {id: clientIdFromProps = ''},
// }) => {
//   const navigation = useNavigation();
//   const {
//     params: {appendPhoneNumber = false},
//   } = route;
//   const [notesCheckboxValue, setNotesCheckboxValue] = useState(true);
//   const [updatedNotes, setUpdatedNotes] = useState('');
//   const [checkedLinks, setCheckedLinks] = useState<any[]>([urlDetails]);
//   const [clientId, setClientId] = useState(clientIdFromProps);
//   const [, setSocialLinksStatus] = useState(true);

//   const handleCheckedLinksChange = (newCheckedLinks: any[]) => {
//     const filteredLinks = newCheckedLinks?.map(({...rest}) => rest);
//     setCheckedLinks(filteredLinks);
//   };

//   const mergeCandidateProfileData = ({
//     clientId,
//     updatedNotes,
//     checkedLinks,
//   }: {
//     clientId: string;
//     updatedNotes: string;
//     checkedLinks: any[];
//   }) => {
//     if (!clientId) return;

//     const data: {
//       clientId: string;
//       urlDetails: any[];
//       notes?: string;
//     } = {
//       clientId: clientId.toString(),
//       urlDetails: checkedLinks,
//     };

//     if (updatedNotes.trim() !== '') {
//       data.notes = updatedNotes;
//     }

//     return data;
//   };

//   const handleMergeProfile = async () => {
//     const candidateProfileData = mergeCandidateProfileData({
//       clientId,
//       updatedNotes,
//       checkedLinks,
//     });

//     await mergeCandidate(recordId, candidateProfileData);
//     navigation.goBack();
//     navigation.goBack();
//     navigation.goBack();
//     onClosePress();
//   };

//   return (
//     <NavigationHeader
//       style={{base: styles.base, title: styles.title}}
//       rightIcons={['close']}
//       onIconPress={getCloseIconPressHandler(onClosePress)}
//       title={MERGE_PROFILES_TITLE}
//       testID={DownlineProfile.mergeScreenSecond}>
//       <Gutter style={styles.contentContainer}>
//         <ScrollView>
//           <Text
//             style={styles.headerText}
//             {...testProperties(DownlineProfile.mergeScreenSecondDescription)}>
//             Please select the items you would like added to the Client profile.
//           </Text>

//           <ContactWithCheckBox
//             candidateId={recordId}
//             setSocialLinksStatus={setSocialLinksStatus}
//             handleCheckedLinksChange={handleCheckedLinksChange}
//             setClientId={setClientId}
//           />

//           <NotesWithCheckbox
//             candidateId={recordId}
//             isDisabled={true}
//             onValueChange={setNotesCheckboxValue}
//             setUpdatedNotes={setUpdatedNotes}
//             setClientId={setClientId}
//             appendPhoneNumber={appendPhoneNumber}
//             notesCheckboxValue={notesCheckboxValue}
//           />
//         </ScrollView>

//         <TouchableOpacity
//           onPress={generateOpenMergePopover({popoverShow}, handleMergeProfile)}
//           style={styles.container}
//           {...testProperties(DownlineProfile.mergeScreenMergeButton)}>
//           <Text style={styles.textStyle}>Merge profiles</Text>
//         </TouchableOpacity>
//       </Gutter>
//     </NavigationHeader>
//   );
// };

/* eslint-disable react/require-default-props */

import React, {useState} from 'react';
import {ScrollView} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {noop} from 'lodash';

import Text from '/component/base/Text';
import TouchableOpacity from '/component/base/TouchableOpacity';
import Gutter from '/component/layout/Gutter';
import NavigationHeader from '/component/layout/NavigationHeader';
import {ContactWithCheckBox} from '/component/screen/CandidateProfile/ContactWithCheckBox';
import NotesWithCheckbox from '/component/screen/CandidateProfile/NotesWithCheckbox';
import {DownlineProfile} from '/constant/TestIDs';
import {MERGE_PROFILES_TITLE} from '/enum/candidates.enum';
import testProperties from '/util/testing/testProperties';

import {getCloseIconPressHandler} from '../MergeCandidate.util';

import {styles} from './SecondMergeScreen.style';
import {generateOpenMergePopover} from './SecondMergeScreen.util';

interface SecondMergeScreenProps {
  onClosePress?: () => void;
  recordId: string;
  mergeCandidate?: (recordId: string, data: any) => Promise<void>;
  popoverShow?: () => void;
  urlDetails?: any[];
  route?: {
    params?: {
      appendPhoneNumber?: boolean;
    };
  };
  clientDetails?: {
    id?: string;
  };
}

export const SecondMergeScreen: React.FC<SecondMergeScreenProps> = ({
  onClosePress = noop,
  recordId,
  mergeCandidate = noop,
  popoverShow = noop,
  urlDetails = [],
  route = {params: {appendPhoneNumber: false}},
  clientDetails = {},
}) => {
  const navigation = useNavigation();
  const appendPhoneNumber = route?.params?.appendPhoneNumber ?? false;
  const clientIdFromProps = clientDetails?.id ?? '';

  const [notesCheckboxValue, setNotesCheckboxValue] = useState(true);
  const [updatedNotes, setUpdatedNotes] = useState('');
  const [checkedLinks, setCheckedLinks] = useState<any[]>([...urlDetails]);
  const [clientId, setClientId] = useState(clientIdFromProps);
  const [, setSocialLinksStatus] = useState(true);

  const handleCheckedLinksChange = (newCheckedLinks: any[]) => {
    const filteredLinks = newCheckedLinks?.map(({...rest}) => rest);
    setCheckedLinks(filteredLinks);
  };

  const mergeCandidateProfileData = ({
    clientId,
    updatedNotes,
    checkedLinks,
  }: {
    clientId: string;
    updatedNotes: string;
    checkedLinks: any[];
  }) => {
    if (!clientId) return;

    const data: {
      clientId: string;
      urlDetails: any[];
      notes?: string;
    } = {
      clientId: clientId.toString(),
      urlDetails: checkedLinks,
    };

    if (updatedNotes.trim() !== '') {
      data.notes = updatedNotes;
    }

    return data;
  };

  const handleMergeProfile = async () => {
    const candidateProfileData = mergeCandidateProfileData({
      clientId,
      updatedNotes,
      checkedLinks,
    });

    if (!candidateProfileData) return;

    await mergeCandidate(recordId, candidateProfileData);
    navigation.goBack();
    navigation.goBack();
    navigation.goBack();
    onClosePress();
  };

  return (
    <NavigationHeader
      style={{base: styles.base, title: styles.title}}
      rightIcons={['close']}
      onIconPress={getCloseIconPressHandler(onClosePress)}
      title={MERGE_PROFILES_TITLE}
      testID={DownlineProfile.mergeScreenSecond}>
      <Gutter style={styles.contentContainer}>
        <ScrollView>
          <Text
            style={styles.headerText}
            {...testProperties(DownlineProfile.mergeScreenSecondDescription)}>
            Please select the items you would like added to the Client profile.
          </Text>

          <ContactWithCheckBox
            candidateId={recordId}
            setSocialLinksStatus={setSocialLinksStatus}
            handleCheckedLinksChange={handleCheckedLinksChange}
            setClientId={setClientId}
          />

          <NotesWithCheckbox
            candidateId={recordId}
            isDisabled={true}
            onValueChange={setNotesCheckboxValue}
            setUpdatedNotes={setUpdatedNotes}
            setClientId={setClientId}
            appendPhoneNumber={appendPhoneNumber}
            notesCheckboxValue={notesCheckboxValue}
          />
        </ScrollView>

        <TouchableOpacity
          onPress={generateOpenMergePopover({popoverShow}, handleMergeProfile)}
          style={styles.container}
          {...testProperties(DownlineProfile.mergeScreenMergeButton)}>
          <Text style={styles.textStyle}>Merge profiles</Text>
        </TouchableOpacity>
      </Gutter>
    </NavigationHeader>
  );
};
